<template>
    <div class="product">
        <loader v-if="!hasLoaded"></loader>

        <template v-else>
            <div class="page-header">
                <h1>
                    {{product.name}}

                    <small>
                        &nbsp;
                        <button class="btn btn-danger btn-fill btn-sm">
                            <span class="fa fa-remove fa-fw"></span>
                            Remove
                        </button>
                    </small>
                </h1>
            </div>

            <div class="row">
                <div class="col-lg-6 col-lg-offset-2 col-md-8 col-md-offset-1 col-sm-12">
                    <form class="form-horizontal">
                        <div class="form-group">
                            <label class="col-sm-4 control-label">Name</label>
                            <div class="col-sm-8">
                                <input type="text" class="form-control" v-model="product.name">
                            </div>
                        </div>

                        <div class="form-group">
                            <label class="col-sm-4 control-label">Price</label>
                            <div class="col-sm-8">
                                <input type="text" class="form-control" v-model="product.price">
                            </div>
                        </div>

                        <br />

                        <div class="form-group">
                            <div class="col-sm-offset-4 col-sm-8">
                                <button type="submit" class="btn btn-primary" @click="update">Update product</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    import Loader from '@/components/layout/Loader'

    const ProductService = require('@/services/products/ProductService')

    export default {
        data() {
            return {
                product: null,
                hasLoaded: false
            }
        },

        mounted() {
            this.load()
        },

        methods: {
            load() {
                ProductService.find(this.$route.params.id, {}, (response) => {
                    const data = response.data

                    this.product = data
                    this.hasLoaded = true
                })
            },

            update() {
                this.hasLoaded = false

                ProductService.update(this.$route.params.id, this.product, (response) => {
                    this.hasLoaded = true
                })
            }
        },

        components: {
            Loader
        }
    }
</script>


// WEBPACK FOOTER //
// View.vue?83181e86